
import * as React from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import CurrencyInput from 'react-currency-input-field';
var valPago = {};
export const FormatMoney = props => {
    const handleChange = e => {
        if (props.onChange) {
          props.onChange({
            dataIndex: 0,
            dataItem: props.dataItem,
            field: props.field,
            syntheticEvent: e.syntheticEvent,
            value: e.target.value
          });
        }
      };

      const {
        dataItem
      } = props;
      const field = props.field || '';
      const dataValue = dataItem[field] === null ? '' : dataItem[field];
      if(field == "quantidade"){
        // if(dataValue == undefined || dataValue == null){
        //   dataValue = ""
        // }else{
        //   props.dataItem.quantidade = dataValue
        // }
        return <td>
        {dataItem.inEdit ? <CurrencyInput type="text" decimalSeparator="," groupSeparator="." precision="3" name="input-name" id='numberboxcell'  onValueChange={(value, name) => console.log(value, name)} className='quantidadeField' onChange={handleChange} value={dataValue == undefined ? '' : dataValue.toString()} /> 
        : (dataValue != undefined ?  dataValue.toString() : undefined)}
      </td>
        // return <td>
        // {dataItem.inEdit ?
        //   <CurrencyInput
        //       id='numberboxcell'
        //       name="input-name"
        //       // defaultValue={0.000}
        //       decimalSeparator="," 
        //       groupSeparator="."
        //       precision="3"
        //       className='quantidadeField'
        //       //value = {props.dataItem.quantidade.toString()}
        //       onValueChange={(value, name) => console.log(value, name)}
        //       onChange={handleChange} /> : props.dataItem.quantidade.toString()
        //   }
        //   </td>
      }else if(field == "ValorPago"){
        return <td>
        {dataItem.inEdit ?
        <CurrencyInput
            id='numberboxcell'
            name="input-name"
            defaultValue={0.000}
            decimalSeparator="," 
            groupSeparator="."
            precision="3"
            className= 'volumepagar'
            onValueChange={(value, name) => console.log(value, name)}
            onChange={handleChange} /> : dataValue.toString()
            
        }
            
        </td>
      }else{
        return <td>
        {dataItem.inEdit ?
        <CurrencyInput
            id='numberboxcell'
            name="input-name"
            defaultValue={0.000}
            decimalSeparator="," 
            groupSeparator="."
            precision="3"
            // intlConfig={{ style: 'currency' ,locale: 'pt-PT', currency: 'EUR' }}
            onValueChange={(value, name) => console.log(value, name)}
            onChange={handleChange} /> : dataValue.toString()
        }
            
        </td>
      }
      
}